export class Alert {
  title: string;
  type: string;
  msg: string;
}

export const AlertType = {
  'success': 'OK!',
  'danger': 'Ошибка!',
  'info': 'Сообщение',
  'warning': 'Внимание'
};



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/models/Alerts.ts